module.exports = __webpack_public_path__ + "static/media/iPad-Pro-Kids_01.62642a74.png";